import React from 'react';
import { AnimatedMetric } from './shared';

const ProofStripSection = () => {
  return (
    <div className="proof-strip" data-testid="proof-strip">
      <div className="container-luxury">
        <p className="text-center text-xs text-[#64748B] uppercase tracking-wider font-medium mb-4 mt-4">Documented Outcomes Across Client Engagements</p>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <AnimatedMetric value="85" suffix="%" label="Brand Loyalty Retained" />
          <div className="proof-item">
            <div className="proof-number">3x</div>
            <div className="proof-label">Reimbursement Approval Rate</div>
          </div>
          <div className="proof-item">
            <div className="proof-number">$100M</div>
            <div className="proof-label">Revenue Impact</div>
          </div>
          <AnimatedMetric value="8" suffix="%" label="Policy Lapse Reduction" />
        </div>
      </div>
    </div>
  );
};

export default ProofStripSection;
